define('Jajuma_ImageOptimizerUltimate/js/gallery/gallery-mixin',['jquery','mage/utils/wrapper'], function ($, wrapper) {
    'use strict';

    if (JajumaUIO.isEnabled) {
        window.loadModernizr();
    }
    return function (initialize) {
        return wrapper.wrap(initialize, function (initialize, config, element) {
            if (!JajumaUIO.isEnabled) {
                return initialize(config, element);
            }
            ModernizrJajuma.on('avif', function(checkAvif) {
                if (checkAvif) {
                    window.browserSupportAvif = true;
                    ModernizrJajuma.on('webp', function(checkWebp) {
                        if (checkWebp) {
                            window.browserSupportWebp = true;
                            $.each(config.data, function (key, value) {
                                value.full = value.full_avif ? value.full_avif : (value.full_webp ? value.full_webp : value.full);
                                value.thumb = value.thumb_avif ? value.thumb_avif : (value.thumb_webp ? value.thumb_webp : value.thumb);
                                value.img = value.img_avif ? value.img_avif : (value.img_webp ? value.img_webp : value.img);
                                config.data[key] = value;
                            });
                        } else {
                            window.browserSupportWebp = false;
                            $.each(config.data, function (key, value) {
                                value.full = value.full_avif ? value.full_avif : value.full;
                                value.thumb = value.full_avif ? value.full_avif : value.thumb;
                                value.img = value.full_avif ? value.full_avif : value.img;
                                config.data[key] = value;
                            });
                        }
                        initialize(config, element);
                    });

                } else {
                    window.browserSupportAvif = false;
                    ModernizrJajuma.on('webp', function(checkWebp) {
                        if (checkWebp) {
                            window.browserSupportWebp = true;
                            $.each(config.data, function (key, value) {
                                value.full = value.full_webp ? value.full_webp : value.full;
                                value.thumb = value.thumb_webp ? value.thumb_webp : value.thumb;
                                value.img = value.img_webp ? value.img_webp : value.img;
                                config.data[key] = value;
                            });
                        }
                        initialize(config, element);
                    });
                }
            });
        });
    };
});

